import { Trans } from '@lingui/macro';
import React, { FC } from 'react';

import PwfSupportedBadge from 'Components/PwfSupportedBadge/PwfSupportedBadge';
import categoryIcon from 'uikit/Icons/Categories';
import routes from 'utils/routeTranslator';
import { usePWFCategoryQuery } from 'utils/hooks/usePWFCategoryQuery';

import './L4Header.scss';

interface Props {
  l4Id: string;
  name: string;
  coverUrl: string;
  mobileCoverUrl: string;
  l2Name: string;
  l2Slug: string;
  l2Id: string;
  nameLocativeCase: string;
  cityName: string;
  isNew: boolean;
  citySlug?: string | null;
  neighbourhoodName?: string;
}

const L4Header: FC<Props> = (props) => {
  const concatHeadingText = (): string => {
    let result: string;

    if (props.nameLocativeCase) {
      result = `${props.name} ${props.nameLocativeCase}`;
    } else {
      result = props.name;
    }

    if (props.neighbourhoodName) result = result + `, ${props.neighbourhoodName}`;

    return result;
  };

  const isPayWithFixly = usePWFCategoryQuery(props.l4Id);

  return (
    <div className="l4Header">
      <picture className="l4Header__background" itemProp="image" itemScope itemType="https://schema.org/ImageObject">
        <div className="l4Header__backgroundWidescreen" style={{ backgroundImage: `url('${props.coverUrl}')` }} />
        <source media="(min-width: 568px)" srcSet={props.coverUrl} />
        <source media="(max-width: 569px)" srcSet={props.mobileCoverUrl} />
        <img
          className="l4Header__backgroundImage"
          src={props.coverUrl}
          alt={`${props.name} ${props.cityName}`}
          itemProp="contentUrl"
        />
        <meta itemProp="representativeOfPage" content="True" />
        <span itemScope itemType="https://schema.org/ImageObject" itemProp="thumbnail">
          <meta content={props.mobileCoverUrl} itemProp="contentUrl" />
        </span>
      </picture>
      {isPayWithFixly && <PwfSupportedBadge className="l4Header__badge" />}
      <div className="l4Header__titleWrapper">
        <a
          className={`l4Header__breadcrumb l4Header__breadcrumb_${props.l2Slug}`}
          href={routes.get('front::categories.type', {
            slug: props.l2Slug,
            city: props.citySlug,
          })}
        >
          <span className="l4Header__categoryIcon">{categoryIcon(props.l2Slug)}</span>
          {props.l2Name}
        </a>
        <span>
          <h1 className="l4Header__title">{concatHeadingText()}</h1>
          {props.isNew && (
            <>
              &nbsp;
              <span className="l4Header__newLabel">
                <Trans>Nowa usługa</Trans>
              </span>
            </>
          )}
        </span>
      </div>
    </div>
  );
};

export default L4Header;
